// @flow
import SubTariff from './SubTariff';

export default SubTariff;
